// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/DINPro-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/DINPro-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/DINPro-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/DINPro-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/DINPro-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/DINPro-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

/* @font-face {
  font-family: dinpro;
  src: url('https://static1.squarespace.com/static/5f1759f10de2dd310eb34d73/t/60f06186baa9e461674a3b49/1626366342619/DINPro+Regular+%282%29.otf');
} */

@font-face {
  font-family: 'DINPro';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: 100;
}
@font-face {
  font-family: 'DINPro';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: 400;
}
@font-face {
  font-family: 'DINPro';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: 700;
}

html {
  font-size: 16px;
  font-family: 'DINPro', Helvetica, Arial, sans-serif;
}
body {
  margin: 0;
}

body.modal-open {
  height: 100vh;
  overflow-y: hidden; /* Hide vertical overflow */
  /*padding-right: 15px; /* Avoid width reflow if necessary*/
  position: fixed;
}

/* Utility to truncate text */
.text-truncator {
  max-width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Utility to space anywhere */
.w-spacer {
  width: 0.5vw;
}
.h-spacer {
  height: 0.5vw;
}

.warning {
  color: red;
}

a {
  text-decoration: none;
  color: inherit;
}

svg {
  display: block;
  margin: auto;
}

input {
  width: 100%;
  padding: 0;
  border: 0;
  outline: none;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
}

.green {
  color: green;
}

.red {
  color: #d92d20;
}
.rotate-90 {
  transform: rotate(90deg);
}

.rotate-270 {
  transform: rotate(270deg);
}

.stroke-green path {
  stroke: #57bb37;
}

.stroke-red path {
  stroke: #d92d20;
}

.stroke-thin path {
  stroke-width: 1px;
}

.blue-link {
  color: blue;
  text-decoration: underline;
}

.blue-link.blue-link:hover {
    text-decoration: underline;
  }
`, "",{"version":3,"sources":["webpack://./src/styles.pcss"],"names":[],"mappings":"AAIA;EACE,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,qBAAqB;EACrB;;8DAE2D;EAC3D,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB;;8DAE4D;EAC5D,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB;;8DAE0D;EAC1D,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB,EAAE,2BAA2B;EAC/C,0DAA0D;EAC1D,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,0BAA0B;AAI5B;;AAHE;IACE,0BAA0B;EAC5B","sourcesContent":["$myColor: red;\n$midDesktop: 990px;\n$sidebarWidth: 312px;\n\n* {\n  box-sizing: border-box;\n}\n\n/* @font-face {\n  font-family: dinpro;\n  src: url('https://static1.squarespace.com/static/5f1759f10de2dd310eb34d73/t/60f06186baa9e461674a3b49/1626366342619/DINPro+Regular+%282%29.otf');\n} */\n\n@font-face {\n  font-family: 'DINPro';\n  src:\n    url('./assets/fonts/DINPro-Light.eot') format('embedded-opentype'),\n    url('./assets/fonts/DINPro-Light.ttf') format('truetype');\n  font-weight: 100;\n}\n@font-face {\n  font-family: 'DINPro';\n  src:\n    url('./assets/fonts/DINPro-Medium.eot') format('embedded-opentype'),\n    url('./assets/fonts/DINPro-Medium.ttf') format('truetype');\n  font-weight: 400;\n}\n@font-face {\n  font-family: 'DINPro';\n  src:\n    url('./assets/fonts/DINPro-Bold.eot') format('embedded-opentype'),\n    url('./assets/fonts/DINPro-Bold.ttf') format('truetype');\n  font-weight: 700;\n}\n\nhtml {\n  font-size: 16px;\n  font-family: 'DINPro', Helvetica, Arial, sans-serif;\n}\nbody {\n  margin: 0;\n}\n\nbody.modal-open {\n  height: 100vh;\n  overflow-y: hidden; /* Hide vertical overflow */\n  /*padding-right: 15px; /* Avoid width reflow if necessary*/\n  position: fixed;\n}\n\n/* Utility to truncate text */\n.text-truncator {\n  max-width: 95%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n/* Utility to space anywhere */\n.w-spacer {\n  width: 0.5vw;\n}\n.h-spacer {\n  height: 0.5vw;\n}\n\n.warning {\n  color: red;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\nsvg {\n  display: block;\n  margin: auto;\n}\n\ninput {\n  width: 100%;\n  padding: 0;\n  border: 0;\n  outline: none;\n  font-family: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\n.green {\n  color: green;\n}\n\n.red {\n  color: #d92d20;\n}\n.rotate-90 {\n  transform: rotate(90deg);\n}\n\n.rotate-270 {\n  transform: rotate(270deg);\n}\n\n.stroke-green path {\n  stroke: #57bb37;\n}\n\n.stroke-red path {\n  stroke: #d92d20;\n}\n\n.stroke-thin path {\n  stroke-width: 1px;\n}\n\n.blue-link {\n  color: blue;\n  text-decoration: underline;\n  &&:hover {\n    text-decoration: underline;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
